export default "__VITE_ASSET__D6YDr$Nq__"